import { gql } from 'apollo-angular';

const GET_ORGANIZATION_PERMISSIONS = gql`
  query organization($id: Long!) {
    organization(id: $id) {
      id
      permissions {
        id
        name
        displayName
        description
      }
    }
  }
`;

export default GET_ORGANIZATION_PERMISSIONS;
